export const toggleState = (event: Event): string | undefined => (event as Event & { newState?: string }).newState;

export const callPopoverSafely = (callback: () => void): boolean => {
  try {
    callback();
    return true;
  } catch {
    // Racing Popover API calls are expected to converge without reaching the application.
    return false;
  }
};
